var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px"
        },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "Home" } } },
            [
              _c("svg-filler", {
                staticClass: "mg-r-auto f-left cs-pointer",
                attrs: {
                  path: "/static/svg/back.svg",
                  fill: "#ffffff",
                  width: "20px",
                  height: "20px"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("\n      ข้อมูลของฉัน\n    ")])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "w-100pct h-60calc" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "t-al-center f-s-18px f-w-bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.userInfo.user.first_name) +
              "  " +
              _vm._s(_vm.userInfo.user.last_name) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "table t-al-center f-s-18px mg-auto pd-hrzt-10px" },
          [
            _c("tr", [
              _c("td", [_vm._v("\n            EmpNo.\n          ")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.userInfo.user.id) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("\n            Branch name\n          ")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.userInfo.user.branch_name) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("\n            POS ID\n          ")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.userInfo.user.pos_id) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("\n            E-mail\n          ")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.userInfo.user.email) +
                    "\n          "
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "t-al-center mg-t-16px" },
          [
            _c(
              "router-link",
              { attrs: { to: { name: "ReportZ" }, exact: "" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white"
                  },
                  [_vm._v(" รายงานสรุปยอดประจำวัน ")]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "t-al-center mg-t-16px" }, [
          _c(
            "div",
            {
              staticClass:
                "reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white",
              on: {
                click: function($event) {
                  _vm.changeBranch()
                }
              }
            },
            [_vm._v(" เปลี่ยนสาขา ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "t-al-center mg-t-21px" }, [
          _c(
            "div",
            {
              staticClass:
                "logOut-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px",
              on: {
                click: function($event) {
                  _vm.logout()
                }
              }
            },
            [_vm._v(" ออกจากระบบ ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.activeModal, canCancel: [] },
          on: {
            "update:active": function($event) {
              _vm.activeModal = $event
            },
            close: function($event) {
              _vm.getBranchNameDisplay()
            }
          }
        },
        [_c("selectStore", { attrs: { cancelBtn: true } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "t-al-center" }, [
      _c("img", {
        staticStyle: { width: "228px" },
        attrs: { src: "/static/img/image/sellsuki.PNG" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1abdedc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1abdedc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-info/UserInfo.vue
// module id = 504
// module chunks = 1